import script from "./TextControlButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextControlButton.vue?vue&type=script&setup=true&lang=ts"

import "./TextControlButton.vue?vue&type=style&index=0&id=23bffd7e&lang=scss"

const __exports__ = script;

export default __exports__